export default (sectionId, requestBody) =>
  new Promise((resolve, reject) => {
    window.axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}/children`, requestBody)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
